<template>
  <router-view v-slot="{ Component }">
    <keep-alive
      :include="[
        'v-bet-jczq',
        'v-bet-jclq',
        'v-bet-bd',
        'v-bet-gy',
        'v-bet-sfc14',
        'v-bet-sfc9',
        'v-bet-pls',
        'v-bet-plw',
        'v-bet-sd',
        'v-bet-klb',
      ]"
    >
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script>
import { initAccountData } from '@/utils/common'

export default {
  name: 'app',
  created() {
    document.title = import.meta.env.VITE_PLATFORM_NAME
    // 登录等页面不用授权
    let arrRoute = ['/login/password', '/login/pns', '/login/sms-up']
    let path = window.location.href.split('#')[1]

    if (arrRoute.includes(path)) {
      return false
    }

    let token = null

    if (import.meta.env.VITE_ENV === 'dev') {
      token = import.meta.env.VITE_TEST_TOKEN
      localStorage.setItem('ltu.token', token)
      initAccountData()
    } else {
      token = localStorage.getItem('ltu.token')
    }

    if (token) {
      initAccountData()
    } else {
      this.$router.push({
        name: 'login-pns',
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
.van-popup .notify-icon {
  animation: notify-frame 0.6s infinite!important;
}

@keyframes notify-frame
{
  0% {opacity:1}
  50% {opacity:0.4}
  100% {opacity:1}
}
</style>
